import {
  ProposalTableColumnFieldTypes,
  ProposalTableCheckLabelStatus,
  ProposalTableFieldType,
} from "@/src/shared/schemas";

export const PROPOSAL_TABLE_KEY = "proposalTable";
export const PROPOSAL_TABLE_COLUMN_KEY = "proposalTableColumn";

export enum ProposalTableRowsKeys {
  Franchise = "franchise",
  MedicalAssistance = "medical_assistance",
  AccidentInsurance = "accident_insurance",
  LiabilityInsurance = "liability_insurance",
  DentalAssistance = "dental_assistance",
  MedicalTransport = "medical_transport",
  OutPatientClinicalCare = "outpatient_clinical_care",
  DocumentBaggageLoss = "document_baggage_loss",
  CarTowing = "car_towing",
}
// helpAssistance_Currency, helpAssistance_Suminsured, suminsured_Accident,  civilSuminsured, civilCurrency
export enum ProposalTableRowsKeysLabels {
  Franchise = "Франшиза",
  MedicalAssistance = "Медична допомога",
  AccidentInsurance = "Страхування від нещасних випадків",
  LiabilityInsurance = "Страхування відповідальності",
  DentalAssistance = "Стоматологічна допомога",
  MedicalTransport = "Медичний транспорт",
  OutPatientClinicalCare = "Амбулаторно-поліклінічна допомога",
  DocumentBaggageLoss = "Втрата документів або багажу",
  CarTowing = "Евакуація автомобіля",
}

export enum ProposalTableColumnsKeys {
  Standard = "Standart", // STANDART in the external system
  Business = "Business",
  Elit = "Elit",
  Vip = "Vip",
}

export const ProposalTableColumns = Object.values(ProposalTableColumnsKeys);

export const INSURED_COUNT_VAR_LIST = [
  "insuredCountAgeFrom0To14",
  "insuredCountAgeFrom15To24",
  "insuredCountAgeFrom25To64",
  "insuredCountAgeFrom65To69",
  "insuredCountAgeFrom70To74",
];

export const DAYS_ABROAD_CONST = 'daysAbroad';
export const WORK_CONST = 'work';
export const COUNTRY_TRAVEL_ZONE_CONST = 'countryTravelZone';
export const TERRORISM_CONST = 'terrorism';
export const TRAVEL_PURPOSE_CONST = 'travelPurpose';
export const PLACE_OF_STAY_ABROAD_CONST = 'placeOfStayAbroad';
export const FOR_TOURISTS_CONST = 'forTourists';
export const PICKED_TRAVEL_CALC_CATEGORY_CONST = 'pickedTravelCalculationCategory';
export const INSURED_TOURISTS_CONST = 'insuredTourists';
export const TRAVEL_TYPE_CONST = 'travelType';

export enum ProposalTableCoverageStatuses {
  COVERED = "COVERED",
  NOT_COVERED = "NOT_COVERED",
}

export const contextFieldNames = [
  "helpAssistance_Suminsured",
  "helpAssistance_Currency",
  "suminsured_Accident",
  "civilSuminsured",
  "civilCurrency",
];

export type ProposalDataType = {
  [key in ProposalTableRowsKeys]: { columnId: ProposalTableColumnsKeys, fields: ProposalTableFieldType[], fields_to_30?: ProposalTableFieldType[]}[];
};

export const proposalData: ProposalDataType = {
  franchise: [
    {
      columnId: ProposalTableColumnsKeys.Standard,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.Text,
          value: "0_EUR",
          label: "0 EUR",
          name: "franchise",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Business,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.Text,
          value: "0_EUR",
          label: "0 EUR",
          name: "franchise",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Elit,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.Text,
          value: "0_EUR",
          label: "0 EUR",
          name: "franchise",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Vip,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.Text,
          value: "0_EUR",
          label: "0 EUR",
          name: "franchise",
        },
      ],
    },
  ],
  medical_assistance: [
    {
      columnId: ProposalTableColumnsKeys.Standard,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.SelectNumber,
          value: "50000.00",
          label: "50 000",
          options: [
            {
              type: ProposalTableColumnFieldTypes.SelectNumber,
              label: "30 000",
              value: "30000.00",
            },
            {
              type: ProposalTableColumnFieldTypes.SelectNumber,
              label: "50 000",
              value: "50000.00",
            },
            {
              type: ProposalTableColumnFieldTypes.SelectNumber,
              label: "60 000",
              value: "60000.00",
            },
            {
              type: ProposalTableColumnFieldTypes.SelectNumber,
              label: "75 000",
              value: "75000.00",
            },
          ],
          name: "helpAssistance_Suminsured",
        },
        {
          type: ProposalTableColumnFieldTypes.SelectCurrency,
          value: "EUR",
          label: "EUR",
          options: [
            {
              label: "EUR",
              value: "EUR",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
            {
              label: "USD",
              value: "USD",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
          ],
          name: "helpAssistance_Currency",
        },
      ],
      fields_to_30: [
        {
          type: ProposalTableColumnFieldTypes.SelectNumber,
          value: "50000.00",
          label: "50 000",
          options: [
            {
              type: ProposalTableColumnFieldTypes.SelectNumber,
              label: "30 000",
              value: "30000.00",
            },
            {
              type: ProposalTableColumnFieldTypes.SelectNumber,
              label: "50 000",
              value: "50000.00",
            },
            {
              type: ProposalTableColumnFieldTypes.SelectNumber,
              label: "60 000",
              value: "60000.00",
            },
            {
              type: ProposalTableColumnFieldTypes.SelectNumber,
              label: "75 000",
              value: "75000.00",
            },
            {
              type: ProposalTableColumnFieldTypes.SelectNumber,
              label: "100 000",
              value: "100000.00",
            },
          ],
          name: "helpAssistance_Suminsured",
        },
        {
          type: ProposalTableColumnFieldTypes.SelectCurrency,
          value: "EUR",
          label: "EUR",
          options: [
            {
              label: "EUR",
              value: "EUR",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
            {
              label: "USD",
              value: "USD",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
          ],
          name: "helpAssistance_Currency",
        },
      ]
    },
    {
      columnId: ProposalTableColumnsKeys.Business,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.SelectNumber,
          value: "60000.00",
          label: "60 000",
          options: [
            {
              label: "30 000",
              value: "30000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
            {
              label: "50 000",
              value: "50000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
            {
              label: "60 000",
              value: "60000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
            {
              label: "75 000",
              value: "75000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
          ],
          name: "helpAssistance_Suminsured",
        },
        {
          type: ProposalTableColumnFieldTypes.SelectCurrency,
          value: "EUR",
          label: "EUR",
          options: [
            {
              label: "EUR",
              value: "EUR",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
            {
              label: "USD",
              value: "USD",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
          ],
          name: "helpAssistance_Currency",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Elit,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.SelectNumber,
          value: "75000.00",
          label: "75 000",
          options: [
            {
              label: "30 000",
              value: "30000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
            {
              label: "50 000",
              value: "50000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
            {
              label: "60 000",
              value: "60000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
            {
              label: "75 000",
              value: "75000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
          ],
          name: "helpAssistance_Suminsured",
        },
        {
          type: ProposalTableColumnFieldTypes.SelectCurrency,
          label: "EUR",
          value: "EUR",
          options: [
            {
              label: "EUR",
              value: "EUR",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
            {
              label: "USD",
              value: "USD",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
          ],
          name: "helpAssistance_Currency",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Vip,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.SelectNumber,
          value: "100000.00",
          label: "100 000",
          options: [
            {
              label: "50 000",
              value: "50000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
            {
              label: "60 000",
              value: "60000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
            {
              label: "75 000",
              value: "75000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
            {
              label: "100 000",
              value: "100000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,

            },
          ],
          name: "helpAssistance_Suminsured",
        },
        {
          type: ProposalTableColumnFieldTypes.SelectCurrency,
          label: "EUR",
          value: "EUR",
          options: [
            {
              label: "EUR",
              value: "EUR",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
            {
              label: "USD",
              value: "USD",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
          ],
          name: "helpAssistance_Currency",
        },
      ],
    },
  ],
  accident_insurance: [
    {
      columnId: ProposalTableColumnsKeys.Standard,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
          value: "80000.00",
          label: "80 000 грн",
          options: [
            { label: "60 000 грн", value: "60000.00", type: ProposalTableColumnFieldTypes.SelectNumberCurrency,  },
            { label: "70 000 грн", value: "70000.00", type: ProposalTableColumnFieldTypes.SelectNumberCurrency,  },
            { label: "80 000 грн", value: "80000.00", type: ProposalTableColumnFieldTypes.SelectNumberCurrency,  },
            { label: "90 000 грн", value: "90000.00", type: ProposalTableColumnFieldTypes.SelectNumberCurrency,  },
            { label: "100 000 грн", value: "100000.00", type: ProposalTableColumnFieldTypes.SelectNumberCurrency,  },
          ],
          name: "suminsured_Accident",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Business,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
          value: "90000.00",
          label: "90 000 грн",
          options: [
            {
              label: "60 000 грн",
              value: "60000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
            {
              label: "70 000 грн",
              value: "70000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
            {
              label: "80 000 грн",
              value: "80000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
            {
              label: "90 000 грн",
              value: "90000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
            {
              label: "100 000 грн",
              value: "100000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
          ],
          name: "suminsured_Accident",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Elit,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
          value: "100000.00",
          label: "100 000 грн",
          options: [
            {
              label: "60 000 грн",
              value: "60000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
            {
              label: "70 000 грн",
              value: "70000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
            {
              label: "80 000 грн",
              value: "80000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
            {
              label: "90 000 грн",
              value: "90000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
            {
              label: "100 000 грн",
              value: "100000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
          ],
          name: "suminsured_Accident",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Vip,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
          value: "100000.00",
          label: "100 000 грн",
          options: [
            {
              label: "60 000 грн",
              value: "60000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
            {
              label: "70 000 грн",
              value: "70000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
            {
              label: "80 000 грн",
              value: "80000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
            {
              label: "90 000 грн",
              value: "90000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
            {
              label: "100 000 грн",
              value: "100000.00",
              type: ProposalTableColumnFieldTypes.SelectNumberCurrency,
            },
          ],
          name: "suminsured_Accident",
        },
      ],
    },
  ],
  liability_insurance: [
    {
      columnId: ProposalTableColumnsKeys.Standard,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.SelectNumber,
          label: "10 000",
          value: "10000.00",
          name: "civilSuminsured",
          options: [
            {
              label: "10 000",
              value: "10000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
            {
              label: "30 000",
              value: "30000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
          ],
        },
        {
          type: ProposalTableColumnFieldTypes.SelectCurrency,
          label: "EUR",
          value: "EUR",
          name: "civilCurrency",
          options: [
            {
              label: "EUR",
              value: "EUR",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
            {
              label: "USD",
              value: "USD",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
          ],
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Business,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.SelectNumber,
          label: "10 000",
          value: "10000.00",
          name: "civilSuminsured",
          options: [
            {
              label: "10 000",
              value: "10000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
            {
              label: "30 000",
              value: "30000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
          ],
        },
        {
          type: ProposalTableColumnFieldTypes.SelectCurrency,
          label: "EUR",
          value: "EUR",
          name: "civilCurrency",
          options: [
            {
              label: "EUR",
              value: "EUR",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
            {
              label: "USD",
              value: "USD",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
          ],
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Elit,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.SelectNumber,
          label: "10 000",
          value: "10000.00",
          name: "civilSuminsured",
          options: [
            {
              label: "10 000",
              value: "10000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
            {
              label: "30 000",
              value: "30000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
          ],
        },
        {
          type: ProposalTableColumnFieldTypes.SelectCurrency,
          label: "EUR",
          value: "EUR",
          name: "civilCurrency",
          options: [
            {
              label: "EUR",
              value: "EUR",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
            {
              label: "USD",
              value: "USD",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
          ],
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Vip,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.SelectNumber,
          label: "10 000",
          value: "10000.00",
          name: "civilSuminsured",
          options: [
            {
              label: "10 000",
              value: "10000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
            {
              label: "30 000",
              value: "30000.00",
              type: ProposalTableColumnFieldTypes.SelectNumber,
            },
          ],
        },
        {
          type: ProposalTableColumnFieldTypes.SelectCurrency,
          label: "EUR",
          value: "EUR",
          name: "civilCurrency",
          options: [
            {
              label: "EUR",
              value: "EUR",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
            {
              label: "USD",
              value: "USD",
              type: ProposalTableColumnFieldTypes.SelectCurrency,
            },
          ],
        },
      ],
    },
  ],
  dental_assistance: [
    {
      columnId: ProposalTableColumnsKeys.Standard,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "yes",
          label: "Так",
          status: ProposalTableCheckLabelStatus.Positive,
          name: "dental_assistance",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Business,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "yes",
          label: "Так",
          status: ProposalTableCheckLabelStatus.Positive,
          name: "dental_assistance",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Elit,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "yes",
          label: "Так",
          status: ProposalTableCheckLabelStatus.Positive,
          name: "dental_assistance",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Vip,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "yes",
          label: "Так",
          status: ProposalTableCheckLabelStatus.Positive,
          name: "dental_assistance",
        },
      ],
    },
  ],
  medical_transport: [
    {
      columnId: ProposalTableColumnsKeys.Standard,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "yes",
          label: "Так",
          status: ProposalTableCheckLabelStatus.Positive,
          name: "medical_transport",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Business,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "yes",
          label: "Так",
          status: ProposalTableCheckLabelStatus.Positive,
          name: "medical_transport",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Elit,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "yes",
          label: "Так",
          status: ProposalTableCheckLabelStatus.Positive,
          name: "medical_transport",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Vip,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "yes",
          label: "Так",
          status: ProposalTableCheckLabelStatus.Positive,
          name: "medical_transport",
        },
      ],
    },
  ],
  outpatient_clinical_care: [
    {
      columnId: ProposalTableColumnsKeys.Standard,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "no",
          label: "Ні",
          status: ProposalTableCheckLabelStatus.Negative,
          name: "outpatient_clinical_care",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Business,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "no",
          label: "Ні",
          status: ProposalTableCheckLabelStatus.Negative,
          name: "outpatient_clinical_care",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Elit,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "no",
          label: "Ні",
          status: ProposalTableCheckLabelStatus.Negative,
          name: "outpatient_clinical_care",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Vip,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "yes",
          label: "Так",
          status: ProposalTableCheckLabelStatus.Positive,
          name: "outpatient_clinical_care",
        },
      ],
    },
  ],
  document_baggage_loss: [
    {
      columnId: ProposalTableColumnsKeys.Standard,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "no",
          label: "Ні",
          status: ProposalTableCheckLabelStatus.Negative,
          name: "document_baggage_loss",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Business,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "yes",
          label: "Так",
          status: ProposalTableCheckLabelStatus.Positive,
          name: "document_baggage_loss",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Elit,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "yes",
          label: "Так",
          status: ProposalTableCheckLabelStatus.Positive,
          name: "document_baggage_loss",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Vip,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "yes",
          label: "Так",
          status: ProposalTableCheckLabelStatus.Positive,
          name: "document_baggage_loss",
        },
      ],
    },
  ],
  car_towing: [
    {
      columnId: ProposalTableColumnsKeys.Standard,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "no",
          label: "Ні",
          status: ProposalTableCheckLabelStatus.Negative,
          name: "car_towing",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Business,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "no",
          label: "Ні",
          status: ProposalTableCheckLabelStatus.Negative,
          name: "car_towing",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Elit,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "yes",
          label: "Так",
          status: ProposalTableCheckLabelStatus.Positive,
          name: "car_towing",
        },
      ],
    },
    {
      columnId: ProposalTableColumnsKeys.Vip,
      fields: [
        {
          type: ProposalTableColumnFieldTypes.CheckLabel,
          value: "yes",
          label: "Так",
          status: ProposalTableCheckLabelStatus.Positive,
          name: "car_towing",
        },
      ],
    },
  ],
};
